
<!-- Таблица -->

<template>

	<div v-on:keyup.enter="() => $emit('apply_filters')">

		<slot name="modal_dialogs"/>

		<b-row>
		<b-col class="col-12">	

			<b-navbar class="px-0">
                <b-col cols="2" class="d-flex justify-content-start p-0" style="min-height: 2.5rem;align-items: center;">
                    <slot name="nav_start"/>
                </b-col>
                <!-- <b-col cols="4" class="d-flex justify-content-center p-0">
                    <slot name="nav_mid"/>
                </b-col> -->
                <b-col cols="10" class="d-flex justify-content-end p-0">
                    <slot name="nav_end"/>
                </b-col>

			</b-navbar>

		</b-col>
		</b-row>

        <slot name="before_table"/>

		<b-table
			ref="table"
			:busy="wait" sticky-header class="elements" style="flex: 1;" small
			:fields="attrs"
			:items="elements"
			:per-page="per_page"
			:current-page="current_page"
			:selectable="selectable"
			:select-mode="select_mode"
			v-on:row-selected="ev => $emit('select', ev)"
			v-on:sort-changed="sort_changed" :sort-by="sort_by" :sort-desc="sort_desc" no-local-sorting
		>

			<template #table-busy>

				<div class="text-center text-primary my-2">

					<b-spinner class="align-middle"></b-spinner>

				</div>

			</template>

			<template v-slot:head(edit)>

				<b-form-checkbox v-on:change="all_edit_change"/>

			</template>

			<template v-slot:head()="data">
				
				<div align-v="top" :draggable="draggable" width="50px" v-on:dragstart="drag_column_begin" v-on:drop="drop_column" v-on:dragover="drag_column" :id="data.field.key" class="table_head_div">
					<slot name="table_head_params" :data="data"/>
					<span v-if="!$scopedSlots.table_head_params" v-html="data.label"/>
				</div>

			</template>

			<template v-slot:cell()="data">
				<slot name="table_cell_params" :data="data"/>
				<span v-if="!$scopedSlots.table_cell_params">{{ data.value }}</span>
				
			</template>

		</b-table>

		<b-row class="small px-3 natural-400" style="font-size: 0.75rem" align-h="between">
		
			<b-col v-if="$slots.footer" cols="2">

				<slot name="footer"/>

			</b-col>

			<b-col cols="6">

					Найдено: {{!this.count ? this.elements.length : this.count}} записей. Показывать на странице по:
					<v-select v-model="per_page" :options="[5, 10, 50]" @input="set_per_page" :clearable="false" :searchable="false" class="v_select_up" style="width: 4.625rem;height: 1.5rem;display: inline-block" />

			</b-col>

			<b-col cols="4">

				<b-pagination ref="paginator" align="right" v-model="current_page" :per-page="per_page" :total-rows="!this.count ? this.elements.length : this.count" aria-controls="table" first-number last-number>
					<template #prev-text><b-icon icon="chevron-left"></b-icon></template>     
					<template #next-text><b-icon icon="chevron-right"></b-icon></template>    
				</b-pagination>

			</b-col>

		</b-row>

	</div>

</template>

<script>

import api from "../../api"

export default
{
	components :
	{
	},

	props :
	{
		attrs : Array,
		elements : Array,
		
		elements_table_height : { type : String, default : () => "80vh" },
		postfix_for_storage_name : String, // default == null
		draggable : { type : Boolean, default : () => true },
		selectable : Boolean,
		select_mode : { type : String, default : () => "single" },

        count : Number,
		initial_per_page : { type : Number, default : () => 10 },

		checkbox : { type : Boolean, default : () => false },
		checkbox_key : String,
	},

	data()
	{
		return {

			attrs_editable : [],

			attrs_visible : [],
			attrs_visible_if_no_visible : [],

			// elements : [],
			ids_for_edit : [],

			simple_query : null,

			is_sort : false,
			sort_by : null,
			sort_desc : null,
			element_word : "",
			per_page : 5,
			from : 0,
			to : 0,
			current_page : 1,
			attrs_ready_flag : false,

			drag_column_id : null,

			filter_button_colored : false,
			wait : false,

			show_table_head_params: false,
			show_table_cell_params: false,

		}
	},

	watch :
	{
		attrs :
		{
			immediate : true,
			
			handler(attrs)
			{
				this.attrs_editable = attrs.filter(attr => attr.editable)
			}
		},

		attrs_visible :
		{
			immediate : true,

			handler(attrs_visible)
			{
				if(this.$refs.table != null)
					this.$nextTick(
						() =>
						{
							this.$emit("attrs_visible_changed", attrs_visible)
						})
				else
					this.$emit("attrs_visible_changed", attrs_visible)
			},
		},
	},

	computed :
	{
		with_xml_export()
		{
			return process.env.VUE_APP_RELEASE != "true"
		},

		has_history()
		{
			return this.$router.history.current.path != this.$router.history._startLocation
			// return window.history.length > 1
		},

		storage_name_filters()
		{
			return api.storage.name(this, "filters")
		},

		storage_name_filters_name()
		{
			return api.storage.name(this, "filters_name")
		},
	},

	filters :
	{
		format_float(value)
		{
			if(value != null)
				return value.toFixed(2)
		},

		format_bool(value)
		{
			return api.format_bool(value)
		},

		format_date(value)
		{
			return api.format_date(value)
		},

		format_time(value)
		{
			return api.format_time(value)
		},

		format_datetime(value)
		{
			return api.format_datetime(value)
		},
	},

	mounted()
	{
		const data = api.cache.paginator.load(this)
		
		if(data.current_page == null)
			this.current_page = 1
		else
			this.current_page = data.current_page

		if(this.initial_per_page == null)
			this.per_page = ( data.per_page == null ) ? 10 : data.per_page
		else
			this.per_page = Number(this.initial_per_page)

		var sort_context = {
			sortBy : null,
			sortDesc : null
		}

		if(data.sort_by != null && data.sort_by != this.initial_sort_by)
		{
			this.is_sort = true
			sort_context.sortBy = data.sort_by
			sort_context.sortDesc = data.sort_desc
		}
		else if(this.initial_sort_by != null)
		{
			sort_context.sortBy = this.initial_sort_by

			if(this.initial_sort_desc == null)
				sort_context.sortDesc = false
			else
				sort_context.sortDesc = this.initial_sort_desc
		}

		this.change_sort(sort_context)

		// return this.attrs_ready.then(
		// 	() =>
		// 	{
		// 		const prev_attr_visible_keys = api.storage.get(this, api.storage.name(this, "attr_visible_keys"), [], Array)

		// 		if(prev_attr_visible_keys.length)
		// 		{
		// 			this.attrs_visible = []

		// 			prev_attr_visible_keys.forEach(
		// 				key =>
		// 				{
		// 					var attr = this.attrs.find(attr => attr.key == key)

		// 					if(attr)
		// 						this.attrs_visible.push(attr)
		// 				})
		// 		}
		// 		else
		// 			this.attrs_visible = this.attrs.filter(attr => attr.visible)

		// 		if(this.many_edit)
		// 			this.attrs_visible.splice(0, 0,
		// 			{
		// 				key : "edit",
		// 				label : ""
		// 			})

		// 		this.attrs_visible_if_no_visible = this.attrs.filter(attr => attr.visible_if_no_visible)
		// 		this.attrs_ready_flag = true
		// 	})
		// 	.then(() => this.$refs.filters.refresh())
		// 	.then(
		// 		() =>
		// 		/*
		// 		{
		// 			const name = this.$route.params.name
		// 			var query = this.$route.params.query

		// 			if(query == null)
		// 				query = this.$route.query.query

		// 			if(query == null || ( api.back.check(this) && this.$refs.filters.exist_tab_local() ))
		// 				this.$refs.filters.load_from_local_storage(false)
		// 			else
		// 				this.$refs.filters.load_from_foreign_storage({ name : name, query : query }, false)
		// 		})*/
		// 		{
		// 			const name = this.$route.params.name
		// 			var query = this.$route.params.query
		// 			const from_post_query = query != null
		// 			var result = false
		// 			var force = false

		// 			if(query == null)
		// 			{
		// 				query = this.$route.query.query
		// 				force = this.$route.query.force
		// 			}

		// 			if(force && query != null)
		// 				this.$refs.filters.load_from_foreign_storage({ name : name, query : query }, false)
		// 			else
		// 			{
		// 				if(! from_post_query)
		// 					result = this.$refs.filters.load_from_local_storage(false)

		// 				if(! result && query != null)
		// 					this.$refs.filters.load_from_foreign_storage({ name : name, query : query }, false)
		// 			}
		// 		})
		// 	.then(() => this.refresh(this.current_page))
	},

	beforeUpdate()
	{
		this.save_to_storage()
	},

	beforeDestroy()
	{
		this.save_to_storage()
	},

	methods :
	{
		format_reference(attr, value)
		{
			if(attr.reference)
			{
				if(attr.reference.simple_values)
				{
					const found = attr.reference.simple_values.find(elem => elem.value == value)

					if(found)
						return found.label
				}
				else
					return api.format_reference(attr.reference, value)
			}

			return value
		},

		save_to_storage()
		{
			if(this.attrs_ready_flag)
				api.storage.set(this, api.storage.name(this, "attr_visible_keys"), JSON.stringify(this.attrs_visible.map(attr => attr.key)))
		},

		refresh_by_filters()
		{
			this.$refs.filters_container.toggle()
			this.$refs.filters.save_to_local_storage()
			this.refresh()
		},

		clear_sort()
		{
			this.is_sort = false
			this.sort_by = this.initial_sort_by
			this.sort_desc = this.initial_sort_desc
		},

		change_sort(ctx)
		{
			var attr_for_sorting

			if(ctx.sortBy == "$natural")
				attr_for_sorting = { key : "$natural" }
			else
				attr_for_sorting = this.attrs.find(elem => elem.key == ctx.sortBy)

			if(attr_for_sorting)
			{
				if(attr_for_sorting.key_for_sort != null)
					this.sort_by = attr_for_sorting.key_for_sort
				else
					this.sort_by = attr_for_sorting.key

				this.sort_desc = ctx.sortDesc
			}
		},

		sort_changed(ctx)
		{
			if(! this.is_sort)
			{
				this.is_sort = true
			}

			this.change_sort(ctx)
		},

		set_per_page(per_page)
		{
			this.per_page = per_page
			this.current_page = 1
		},

		get_element_word(count)
		{
			return api.words.element.accusative(count, this.$props.essence_name_for_plural_1, this.$props.essence_name_for_plural_234, this.$props.essence_name_for_plural_others)
		},

		all_edit_change(value)
		{
			this.ids_for_edit = []

			if(value)
				this.elements.forEach(elem => this.ids_for_edit.push(elem.id))
		},

		drag_column_begin(event)
		{
			this.drag_column_id = event.srcElement.id
		},

		drag_column(event)
		{
			event.preventDefault();
		},

		drop_column(event)
		{
			var to_column_id = event.srcElement.id

			var drag_id = null
			var to_id = null

			this.attrs_visible.forEach(
				( elem, index ) =>
				{
					if(elem.key == this.drag_column_id)
						drag_id = index

					if(elem.key == to_column_id)
						to_id = index
				})

			var drag_attr = this.attrs_visible[drag_id]

			if(drag_id < to_id)
			{
				this.attrs_visible.splice(to_id + 1, 0, drag_attr)
				this.attrs_visible.splice(drag_id, 1)
			}
			else
			{
				this.attrs_visible.splice(to_id, 0, drag_attr)
				this.attrs_visible.splice(drag_id + 1, 1)
			}
		},
	}
}

</script>

<style>
	.navbar .nav-item a
	{
		padding-inline: .5625rem;
	}
	
	.navbar .nav
	{
		gap: .5rem;
	}
	
</style>
